import { AutocompleteField } from "@wayflyer/flyui";
import { ReferencedStackedLineChart, ChartFilterSwitches, TemporalResolutionPickers } from "@wayflyer/flyui-dataviz";
import React from "react";
// eslint-disable-next-line no-restricted-imports

import type { UIElement } from "../utils/types";

import { Container, FlexContainer, Spacer } from "./ui/styled";

const makeMultiSelectHeader = (config): UIElement => {
  if (config.select) {
    const msbLabel = config.select.dropdownLabel;
    return (
      <AutocompleteField
        name={msbLabel}
        placeholder={msbLabel}
        multi="nowrap"
        value={config.elements.filter((tile) => tile.enabled).map((tile) => tile.type)}
        clearable={false}
        options={config.elements.map((tile) => ({ id: tile.type, text: tile.type }))}
        onChange={(values) => {
          config.elements.forEach((tile) => {
            const enabled = values.includes(tile.type);
            if (enabled !== tile.enabled) {
              config.select.onEnable(enabled, tile.type);
            }
          });
        }}
      />
    );
  } else {
    return null;
  }
};

const makeComboHeader = (config): UIElement => {
  if (config.select) {
    return (
      <Container style={{ minWidth: "150px" }}>
        <AutocompleteField
          name={config.select.name}
          label={config.select.label}
          initialValue={config.select.initialValue}
          options={config.elements.map((tile) => {
            return {
              id: tile.type,
              text: tile.type,
            };
          })}
          onChange={(id) => {
            const tile = config.elements.find((tile) => tile.type === id);
            if (tile) {
              config.select.onChange(tile);
            }
          }}
        />
      </Container>
    );
  } else {
    return null;
  }
};

export interface GraphProps {
  chartData: any;
  channelSelect: any;
  metricSelect: any;
  referenceToggle: any;
  resolutionPickers: any;
  chartFilters: any;
}

export const Graphs = ({
  chartData,
  channelSelect,
  metricSelect,
  resolutionPickers,
  chartFilters,
}: GraphProps): UIElement => {
  return (
    <Container>
      <FlexContainer>
        {makeMultiSelectHeader(channelSelect)}
        <Spacer />
        {makeComboHeader(metricSelect)}
        <Spacer />
        <TemporalResolutionPickers {...resolutionPickers} />
        <Spacer />
        <ChartFilterSwitches {...chartFilters} />
      </FlexContainer>
      {chartData ? <ReferencedStackedLineChart {...chartData} /> : null}
    </Container>
  );
};
